import { useNavigate } from "react-router-dom";
import { useState } from "react";
import {
  Box,
  Tab,
  Tabs,
} from "@mui/material";
import React from "react";
import AllTransactions from "../../features/transction-history/AllTransactions";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

// TableHeader component removed (unused)

const ManageTransction = () => {
  const navigate = useNavigate();
  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  return (
    <>
      <div className="main_title">
        <h1>Transactions & Loyalty Logs</h1>
        <p>
          <button
            onClick={() => navigate("/dashboard")}
            className="btn btn_primary"
          >
            Dashboard
          </button>{" "}
          - Transactions & Loyalty Logs
        </p>
      </div>

      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              {/* <Tab label="Transction History" {...a11yProps(0)} />
              <Tab label="Points Adjustment Log" {...a11yProps(1)} /> */}
            </Tabs>
          </Box>
        </div>
      </div>

      <div className="cards">
        <AllTransactions />
      </div>
    </>
  );
};

export default ManageTransction;
